import { FIRST_MONTH_COUPON } from '@/components/app/layout/OfferBannerProvider/bannerCopy';
import { Prices } from '@/store/prices/types';

export type ActiveOffer =
	| { type: 'firstMonth'; couponId: string; amountOff: number }
	| { type: 'percentOff'; couponId: string; percentOff: number };

export type ActiveOfferType = ActiveOffer['type'];

export const getActiveOffer = (prices: Prices | undefined): ActiveOffer | null => {
	const monthly = prices?.coupons?.monthly;
	if (monthly?.id === FIRST_MONTH_COUPON && typeof monthly.amount_off !== 'undefined') {
		return { type: 'firstMonth', couponId: monthly.id, amountOff: monthly.amount_off };
	}
	const yearly = prices?.coupons?.yearly;
	if (typeof yearly?.percent_off !== 'undefined') {
		return { type: 'percentOff', couponId: yearly.id, percentOff: yearly.percent_off };
	}
	return null;
};
